import React from "react";
import { connect } from "react-redux";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { updateNupCalendarTypeSelection, updateShowChart } from "../../../../Actions/NupViewActions.js";
import { CalendarType } from "../../../../Constants/ListManagerCalendarConstants.js";
import ONeilViewStore from "ONeilViewStore";
import CalendarIcon from "./CalendarIcon.jsx";
import BaseServiceApi from "BaseServiceApi";
import UserInfoUtil from "UserInfoUtil";
import Tooltip from './Tooltip'; 

const EntitlementType = BaseServiceApi.rayData["EntitlementType"];


const CalendarDropup = (props) => {
  const isAIEventEntitled = UserInfoUtil.IsUserEntitled(EntitlementType.AI_FUTURE_EVENTS_Entitlement)
  const isPanarayEventEntitled = UserInfoUtil.IsUserEntitled(EntitlementType.CALENDAR_EVENTS_XDIV_Entitlement) ||
    UserInfoUtil.IsUserEntitled(EntitlementType.CALENDAR_EVENTS_EPS_Entitlement);
  const handleCalendarTypeSelection = (type) => {
    props.updateNupCalendarTypeSelection(type);
    ONeilViewStore.showChart = false;
    props.updateShowChart(false);
  };

  const renderMenuItem = (label, type, disabled = false) => {
    const isActive = props.listViewType === type;
    return (
      <MenuItem
        onClick={() => (!disabled ? handleCalendarTypeSelection(type) : null)}
        active={isActive}
        disabled={disabled}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          fontWeight: isActive ? "600" : "normal",
          position: "relative",
        }}
      >
        {isActive && (
          <span
            style={{
              color: "#000",
              fontSize: "14px",
              marginRight: "4px",
              display: "inline-block",
              width: "12px",
              textAlign: "center",
              position: "absolute",
              left: "1px",
            }}
          >
            ✓
          </span>
        )}
        {!isActive && (
          <span
            style={{
              width: "12px",
              display: "inline-block",
              marginRight: "4px",
            }}
          />
        )}
        <div style={{ marginLeft: "4px" }}>{label}</div>
      </MenuItem>
    );
  };

  return (
    <DropdownButton
      id="icn-menu"
      noCaret
      drop="up-centered"
      style={{ width: "30px", height: "22px", cursor: "pointer" }}
      className={props.listViewType !== CalendarType.NONE ? "selective" : ""}
      title={
        <Tooltip
          text={"Calendar View"}
          tooltipClass="several-view-tooltip"
          placement="top"
          space={30}
          fixed={true}
        >
          <span style={{ width: "28px", height: "20px", display: "inline-block", cursor: "pointer" }}>
            <CalendarIcon
              style={{
                width: "16px",
                height: "16px",
                marginTop: "2px",
                marginRight: "1px",
                pointerEvents: "none",
              }}
            />
          </span>
        </Tooltip>
      }
    >
      {renderMenuItem(
        "AI Event",
        CalendarType.AI_EVENT,
        !isAIEventEntitled
      )}
      {renderMenuItem("Panaray Event", CalendarType.PANARAY_EVENT, !isPanarayEventEntitled)}
    </DropdownButton>
  );
};

const mapStateToProps = ({ listViewReducer }) => {
  const { NupViewReducer } = listViewReducer;
  return { listViewType: NupViewReducer.listViewType };
};

const mapDispatchToProps = (dispatch) => ({
  updateNupCalendarTypeSelection: (item) =>
    dispatch(updateNupCalendarTypeSelection(item)),
  updateShowChart: (value) => dispatch(updateShowChart(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarDropup);
